import { AdminUiDetailApiModel } from '@cxb/editor-stb-api';
import { AdminUiDetails } from '../../domain/admin-ui-details';
import { mapAdminUiMenuItemsApiToDomain } from './map-admin-ui-menu-items-api-to-domain';

export const mapApiAdminUIDetailsToDomain = ({ menuItems }: AdminUiDetailApiModel): AdminUiDetails => {
  return {
    menuItems: mapAdminUiMenuItemsApiToDomain(menuItems),
  };
};
